import * as React from 'react'
import * as ThemeUI from 'theme-ui'
import * as PropTypes from 'prop-types'

import * as Herz from '@rushplay/herz'

export function CustomFieldError(props) {
  const translate = Herz.I18n.useTranslate(
    () => [props.translationKey],
    [props.translationKey]
  )

  return (
    <ThemeUI.Grid
      sx={{
        gridGap: '4px',
        overflow: 'hidden',
        wordBreak: 'break-word',
        paddingTop: '4px',
      }}
    >
      <ThemeUI.Text
        sx={{
          fontSize: 'xs',
          fontFamily: 'body',
          color: 'danger',
        }}
      >
        {translate(props.translationKey)}
      </ThemeUI.Text>
    </ThemeUI.Grid>
  )
}

CustomFieldError.propTypes = {
  translationKey: PropTypes.string,
}
